// RxJS
import {throwError as observableThrowError,  Observable, of } from 'rxjs';
import {map, catchError, concatMap} from 'rxjs/operators';
// Angular
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import {OriginService, WguOauth2Service} from "@wgu-edu/oauth2";
import { AuthToken } from '@wgu-edu/oauth2/lib/model/auth-token';
import {EnvironmentService} from "./services/environment.service";
import {SafeLogger} from "./utils/safe-logger";
// App
// import { OriginService } from '../service/origin.service';
// import { WguOauth2Service } from '../service/auth.service';
// import { AuthFlowService } from '../service/auth-flow.service';


@Injectable({
  providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {
  private trustedDomains: string[] = [];

  constructor(
    private injector: Injector,
    private originService: OriginService,
    private wguOauth2Service: WguOauth2Service,
    private environmentService: EnvironmentService
  ) {
    this.trustedDomains.push(this.environmentService.environment.emApiGatewayURL);
    this.trustedDomains.push(this.environmentService.environment.samBaseUrl);
    this.trustedDomains.push(this.environmentService.environment.apiPersonBaseUrl);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // This is the one case where we don't have an Authorization header to attach yet.
    if (request.url.endsWith('/token.oauth2')) {
      return next.handle(request); // This is the only HTTP request without Authorization.
    }

    if (!this.isValidUrl(request.url)) {
      SafeLogger.log("Stopping unauthorized Host request");
      return next.handle(null);
    }

    // if (this.wguOauth2Service.a)

    // Avoid the circular dependency in constructor by getting a lazy reference to the auth service.
    // if (!this.authFlowService) { this.authFlowService = this.injector.get(AuthFlowService); }

    // If we're already authenticated, shortcut the delayed token by getting it synchronously.
    if (this.wguOauth2Service.isAuthenticated()) {
      const token = this.wguOauth2Service.authTokenService.getToken();

      return next.handle(this.addAuth(request, token))
        .pipe(
          catchError(this.handleError())
        );
    }

    return this.addAuthAsync(request).pipe(
      concatMap(request => next.handle(request)),
      catchError(this.handleError()));
  }

  private isValidUrl(request: string): boolean {
    let result = false;
    this.trustedDomains.forEach(host => {
      result = result || request.startsWith(host);
    });
    return result;
  }

  private handleError() {
    return (error: any) => {
      if (error instanceof HttpErrorResponse) {
        switch (error.status) {
          case 403:
          case 401:
            if (error.error.message === 'Failed to Authenticate' || error.error.reason === 'TOKEN_EXPIRED') {
              this.wguOauth2Service.authTokenService.removeToken(); // Force reauthentication.
              return this.wguOauth2Service.authTokenService.getFromStore();
            }
            this.originService.removeOrigin();
            // Falls into...
            break;
          default:
            return observableThrowError(error);
        }
      }
      return of(error);
    };
  }

  private addAuthAsync(request: HttpRequest<any>): Observable<HttpRequest<any>> {
    const observable = this.wguOauth2Service.authTokenService.getFromStore();
    return observable.pipe(
      map(token =>
        !token
          ? request
          : this.addAuth(request, token)
      ));
  }

  private addAuth(request: HttpRequest<any>, token: any): HttpRequest<any> {
    return request.clone({setHeaders: {Authorization: `Bearer ${token.access_token}`}});
  }
}
